import { useEffect, useState } from "react"

export default function useWindowDimensions() {
    const getWindowDimensions = () => {
        const { innerWidth: width, innerHeight: height } = window
        return {
            width,
            height,
        }
    }

    const [windowDimensions, setWindowDimensions] = useState({ width: undefined, height: undefined })

    useEffect(() => {
        setWindowDimensions(getWindowDimensions())
        const handleResize = () => setWindowDimensions(getWindowDimensions())
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    return windowDimensions
}
